'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TableRow = require('./components/TableRow.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TableRow).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-table/lib/components/table-row/index.js
// module id = 1354
// module chunks = 1